import React from 'react'
import { Header } from 'antd/es/layout/layout'
import { useNavigate } from 'react-router'
import { Color } from '../../../../Common/Color'
import { Flex } from 'antd'
import MobileAssistancePhone from './MobileAssistancePhone'
import MobileSearch from './MobileSearch'

export default function MobilePublicHeader ({ withSearch = false }) {
  const navigate = useNavigate()

  return (<>
    <Header style={{
      backgroundColor: Color.white,
      '--ant-layout-header-padding': '12px 10px',
      '--ant-layout-header-height': withSearch ? '180px' : '75px',
      lineHeight: '20px'
    }}>
      <Flex align='center' justify='space-around'>
        <img onClick={() => navigate('/')} style={{ cursor: 'pointer' }} className="logo" src="/images/logo-lbm-blanc.svg" alt='Logo' width="150px" />
        <MobileAssistancePhone />
      </Flex>
      { withSearch && <MobileSearch /> }
    </Header>
  </>
  )
}
